import React from 'react';

class BirthDateWithHighlight extends React.Component {


    render() {
        if (this.props.isFullDate) return <span>{this.props.dateAsString}</span>;

        let parts = this.props.dateAsString.split('/');
        return <span><span style={{ color: '#8d949e'}}>{parts[0]}</span>/<span>{parts[1]}</span></span>;
    }
    
}

export default BirthDateWithHighlight;